import { render, staticRenderFns } from "./global-modal-chat-ia.vue?vue&type=template&id=64391f3c&scoped=true&"
import script from "./global-modal-chat-ia.vue?vue&type=script&lang=js&"
export * from "./global-modal-chat-ia.vue?vue&type=script&lang=js&"
import style0 from "./global-modal-chat-ia.vue?vue&type=style&index=0&id=64391f3c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64391f3c",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64391f3c')) {
      api.createRecord('64391f3c', component.options)
    } else {
      api.reload('64391f3c', component.options)
    }
    module.hot.accept("./global-modal-chat-ia.vue?vue&type=template&id=64391f3c&scoped=true&", function () {
      api.rerender('64391f3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/global/modal/global-modal-chat-ia/global-modal-chat-ia.vue"
export default component.exports